import {ENUMS} from "./enums";
import WebinarPage from "../modules/auth/WebinarPage";
import RegisterPage from "../modules/auth/RegisterPage";

export const BillingSpecials = {
  // https://app.forefrontcrm.com/Webinar_Special_2022
  Webinar_Special_2022: {
    routerKey: 'webinarspecial',
    type: ENUMS.BillingSpecialEnum.WebinarSpecial.value,
    plan: ENUMS.BillingPlanEnum.Pro.value,
    name: 'Webinar Special',
    planAfterInitialPeriodLineItemDescription: 'Pro Plan after 6 months',
    billingCycle: ENUMS.BillingCycleEnum.Monthly.value,
    coupon: ENUMS.CouponCodeEnum.WEBINARSPECIAL2022.value,
    isActive: true,
    closeDate: null,
    initialCharge: 997.00,
    bullets: [
      {
        text: 'Forefront CRM Pro for 6 months',
        value: '$1,194',
      },
      {
        text: 'Follow up sequences that convert',
        value: '$499',
      },
      {
        text: 'Done for you setup fee waived',
        value: '$499',
      },
      {
        text: 'Inbound Call Script that converts',
        value: '$199',
      },
      {
        text: 'John Martinez\'s Setting the Stage Training',
        value: '$999',
      },
      {
        text: 'Entire Flip Hacking Live Recordings',
        value: '$999',
      },
      {
        text: 'Don Costa\'s Training Event Recordings',
        value: '$1,999',
      },
    ],
    specialText: '<strong>Only $997 today</strong> and then $199 per month after your free 6 months',
    disclaimerRecurringChargeText: `For the next six months, you will only be charged usage fee's for phone's.  After that you will be charged $199 plus taxes.`,

  },
  findByType(billing_special) {
    if (billing_special === BillingSpecials.Webinar_Special_2022.type) {
      return BillingSpecials.Webinar_Special_2022;
    }

    return null;
  },
  findByRouterKey(specialKey) {
    if (specialKey === BillingSpecials.Webinar_Special_2022.routerKey) {
      return BillingSpecials.Webinar_Special_2022;
    }

    return null;
  },
  routes() {
    return [
      {
        path: '/webinar-special',
        name: 'webinar1',
        // We are no longer running billing specials so redirecting this to the normal registration page
        component: RegisterPage,
        meta: {
          requiresAuth: false,
        }
      },
      {
        path: '/webinarspecial',
        name: 'webinar2',
        // We are no longer running billing specials so redirecting this to the normal registration page
        component: RegisterPage,
        meta: {
          requiresAuth: false,
        }
      },
    ];
  }
}

